module.exports = __webpack_public_path__ + "img/caetano-go-logo.98afc662.svg";